/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdPhotoQueryResponse,
  GetApiV1PersonIdPhotoPathParams,
  GetApiV1PersonIdPhoto401,
  GetApiV1PersonIdPhoto404,
  GetApiV1PersonIdPhoto500,
} from "../../types/personRegisterController/GetApiV1PersonIdPhoto.ts";

function getGetApiV1PersonIdPhotoUrl(
  id: GetApiV1PersonIdPhotoPathParams["id"],
) {
  const res = { method: "GET", url: `/api/v1/person/${id}/photo` as const };
  return res;
}

/**
 * @description Retorna a foto de perfil da pessoa. **(Requer Authorization para autenticação)**
 * @summary Obter foto de perfil (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/photo}
 */
export async function getApiV1PersonIdPhoto(
  id: GetApiV1PersonIdPhotoPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdPhotoQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdPhoto401
      | GetApiV1PersonIdPhoto404
      | GetApiV1PersonIdPhoto500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdPhotoUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
